import React, { useEffect, useState } from "react";
import UpperPage from "../../../Components/UpperPage/UpperPage";
import { GET_UNITS } from "./Api";
import UnitCard from "../../../Components/Elements/UnitCard/UnitCard";
import UnitFilters from "../../../Components/Elements/UnitFilters/UnitFilters";
import "./Listing.css";

function Listing() {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({});

  const fetchUnits = async (filterParams = {}) => {
    try {
      setLoading(true);
      const response = await GET_UNITS(filterParams);
      setUnits(response.Data);
      setError(null);
    } catch (err) {
      console.error("Error fetching units:", err);
      setError("Failed to load units. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnits();
  }, []);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    fetchUnits(newFilters);
  };

  return (
    <>
      <UpperPage Title={"Units Listing"} />
      
      <div className="listing-content">
        <UnitFilters onFilterChange={handleFilterChange} />
        
        {loading ? (
          <div className="loading-container">
            <p>Loading units...</p>
          </div>
        ) : error ? (
          <div className="error-container">
            <p>{error}</p>
          </div>
        ) : units.length === 0 ? (
          <div className="no-results">
            <p>No units found matching your criteria.</p>
          </div>
        ) : (
          <div >
            {units.map((unit) => (
              <UnitCard key={unit.id} unit={unit} />
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default Listing;
